import { loginA, logoutA } from '@/api/session'
import debugLog from '@/utils/debugLog'
import { resetRouter } from '@/router'

// const blank_user = {name: '', email: ''}

const state = {
  token: '',
  // exp: '',
  user_id: '',
  user_name: '',
  // email: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER: (state, user) => {
    state.user_name = user.name
    state.user_id = user.id
  },
  CLEAR_USER: (state) => {
    // state.token = '',
    // state.exp = '',
    state.user_name = '',
    // state.email = '',
    state.user_id = null
  }
}

const actions = {
  async login ({ commit }, userInfo) {
    const { login, password } = userInfo
    try {
      const res = await loginA({login: login.trim(), password: password})
      if (res.status == 200) {
        await commit('SET_USER', res.data)
        return 'OK'
      }
    } catch (error) {
      debugLog(error)
    }
    commit('CLEAR_USER')
    return 'NG'
  },
  async logout ({ commit }) {
    await logoutA()
    await commit('CLEAR_USER')
    resetRouter()
  },
  async needAuth({ commit }) {
    await commit('CLEAR_USER')
    resetRouter()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
